/**
 * Clamps value between min and max and returns value.
 *
 * @param value The value to clamp.
 * @param min The min bound.
 * @param max The max bound.
 * @returns Returns the clamped number.
 * @example
 *
 * clamp(-10, -5, 5)
 * // => -5
 *
 * clamp(10, -5, 5)
 * // => 5
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
